<template>
  <div class="content">
    <form>
      <kirim-form :datas="dataall"></kirim-form>
      <kontragent :datas="dataall"></kontragent>
      <firma></firma>
      <sklad :datas="dataall"></sklad>
      <paytype :datas="dataall"></paytype>
    </form>

    <!-- Zamonaviy modal — saqlanmagan ma'lumot -->
    <div v-if="showUnsavedModal" class="usm-overlay" @click.self="cancelUnsaved">
      <div class="usm-modal">
        <div class="usm-icon"><b-icon icon="exclamation-triangle-fill"></b-icon></div>
        <h3 class="usm-title">Saqlanmagan o'zgarishlar mavjud</h3>
        <p class="usm-text">Kirim hujjatidagi o'zgarishlar saqlanmagan. Nima qilamiz?</p>
        <div class="usm-actions">
          <button type="button" class="usm-btn usm-save" @click="onSaveYes">
            <b-icon icon="check-circle-fill"></b-icon> Saqlash
          </button>
          <button type="button" class="usm-btn usm-discard" @click="onDiscard">
            <b-icon icon="trash-fill"></b-icon> Saqlamasdan chiqish
          </button>
          <button type="button" class="usm-btn usm-cancel" @click="cancelUnsaved">
            <b-icon icon="arrow-left"></b-icon> Bekor qilish
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { KirimForm, Kontragent, Sklad, Firma, Paytype } from "@/pages";
export default {
  components: {
    KirimForm,
    Kontragent,
    Sklad,
    Firma,
    Paytype
  },
  watch: {
    dataall: {
      deep: true,
      handler(val, oldVal) {
        this.$store.state.saved += 1;
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$root.$refs.prixod.SaveSettings();
    if (this.$store.state.saved < 2) {
      this.$store.state.saved = null;
      localStorage.removeItem("prostatka");
      next();
      this.$store.state.selected_index = null;
    } else {
      this._pendingNext = next;
      this.showUnsavedModal = true;
    }
  },
  data() {
    return {
      watch: false,
      update_password: "",
      showUnsavedModal: false,
      _pendingNext: null,
      dataall: {}
    };
  },
  methods: {
    onSaveYes() {
      this.showUnsavedModal = false;
      if (this.$root.$refs.prixod && this.$root.$refs.prixod.Savedokument) {
        this.$root.$refs.prixod.Savedokument();
      }
      if (this._pendingNext) { this._pendingNext(false); this._pendingNext = null; }
    },
    onDiscard() {
      this.showUnsavedModal = false;
      this.$store.state.saved = null;
      localStorage.removeItem("prostatka");
      if (this._pendingNext) { this._pendingNext(); this._pendingNext = null; }
    },
    cancelUnsaved() {
      this.showUnsavedModal = false;
      if (this._pendingNext) { this._pendingNext(false); this._pendingNext = null; }
    },
    Home() {
        this.$store.state.saved = null;
        this.showUnsavedModal = false;
        this.$router.push({ name: "Кирим" });
      },
    Data() {
      let self = this;
      axios
        .get("api/v1/prixod/id/" + self.$route.params.id)
        .then(function(response) {
          self.dataall = response.data;
          console.log(response.data);
          // self.dataall.created_at=new Date(response.data.created_at * 1000).toISOString().substr(0, 16);
          setTimeout(() => {
            self.watch = true;
          }, 100);
        });
    },
    Sklad() {
      let self = this;
      axios
        .get("api/v1/sklads/id/" + localStorage.getItem("sklad_id"))
        .then(function(response) {
          self.update_password = response.data.update_password;
        });
    }
  },
  created: function() {
    this.Data();
    this.Sklad();
  }
};
</script>

<style scoped>
.usm-overlay {
  position: fixed; inset: 0;
  background: rgba(15, 23, 42, 0.55);
  backdrop-filter: blur(6px);
  z-index: 9999;
  display: flex; align-items: center; justify-content: center;
  padding: 16px;
  animation: usm-fade 0.18s ease-out;
}
@keyframes usm-fade { from { opacity: 0; } to { opacity: 1; } }

.usm-modal {
  background: white; border-radius: 22px; width: 100%; max-width: 460px;
  padding: 32px 26px 24px; text-align: center;
  box-shadow: 0 25px 60px rgba(0, 0, 0, 0.25);
  animation: usm-pop 0.25s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
@keyframes usm-pop {
  0% { transform: scale(0.85); opacity: 0; }
  100% { transform: scale(1); opacity: 1; }
}

.usm-icon {
  width: 72px; height: 72px; margin: 0 auto 16px;
  border-radius: 50%;
  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
  display: flex; align-items: center; justify-content: center;
  font-size: 38px; color: #d97706;
  box-shadow: 0 8px 20px rgba(217, 119, 6, 0.2);
}

.usm-title {
  font-weight: 800; font-size: 19px; color: #0f172a; margin: 0 0 8px;
}

.usm-text {
  font-size: 14px; color: #64748b; line-height: 1.5; margin: 0 0 22px;
}

.usm-actions {
  display: grid; grid-template-columns: 1fr; gap: 8px;
}

.usm-btn {
  border: none; padding: 12px 18px; border-radius: 12px;
  font-weight: 700; font-size: 14px; cursor: pointer;
  display: flex; align-items: center; justify-content: center; gap: 8px;
  transition: 0.2s;
}
.usm-btn:hover { transform: translateY(-1px); box-shadow: 0 6px 14px rgba(0, 0, 0, 0.12); }
.usm-btn svg { font-size: 16px; }

.usm-save {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
}
.usm-save:hover { box-shadow: 0 8px 20px rgba(16, 185, 129, 0.4); }

.usm-discard {
  background: white; color: #e11d48; border: 1.5px solid #fecdd3;
}
.usm-discard:hover { background: #e11d48; color: white; border-color: #e11d48; }

.usm-cancel {
  background: #f1f5f9; color: #64748b;
}
.usm-cancel:hover { background: #e2e8f0; color: #0f172a; }
</style>
